export default __webpack_public_path__ + "static/media/Checkers_GIF.65243026.gif";